<!-- <p>complete-action works!</p> -->
<app-dialog-header headerText="{{headerText}}" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
    <div mat-dialog-content style="max-width: 500px;">
        <span>{{dialogText}}</span>
        <mat-form-field>
            <mat-label>Comment</mat-label>
            <textarea matInput formControlName="comment" maxlength="201"></textarea>
            <mat-hint align="end">{{ getCommentLength() }}/{{maxLength}}</mat-hint>
        </mat-form-field>
        <mat-error *ngIf="dialogForm.get('comment')!.hasError('required')">Comment is required</mat-error>
        <mat-error *ngIf="dialogForm.get('comment')!.hasError('maxlength')">Comment max Length {{maxLength}}
            Chars</mat-error>

        <div style="color: black;" class="rule-box" *ngIf="ruleList && ruleList.length > 0">
            <div *ngFor="let rule of ruleList let i = index" class="rule-item"
                [ngStyle]="{'border-bottom': i != ruleList.length - 1 ? '1px solid lightgray' : ''}">
                <span>{{ rule.RuleDescription }}:</span>
                <span>{{makeRuleReadable(rule)}}</span>
            </div>
        </div>

        <div class="rule-options" *ngIf="!hideRules">
            <ejs-dropdownlist #dropdown [dataSource]='ruleOptions' placeholder="Rule Choice" [fields]="ruleFields"
                formControlName="ruleChoice" (change)="ruleChoiceChange($event)">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.text }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>

            <div class="alignRow">
                <ejs-numerictextbox (change)="delayChange($event)" [step]="1" formControlName="delay"
                    cssClass="e-custom" placeholder="Delay" max="90" min="1">
                </ejs-numerictextbox>
                <span>days</span>
            </div>
        </div>

        <div class="further-action alignRow">
            <span>Create Further Action</span>
            <mat-checkbox color="primary" formControlName="createFurtherAction"></mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="dialogForm.value" [disabled]="dialogForm.invalid">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</form>
